<script setup lang="ts">
import { GraduationCap, Laptop } from "lucide-vue-next"
import { computed } from "vue"

import SetStudyDialog from "@/components/manager/settings/SetStudyDialog.vue"
import SetTeleworkDialog from "@/components/manager/settings/SetTeleworkDialog.vue"
import { Button } from "@/components/ui/button"
import { Card, CardHeader, CardTitle } from "@/components/ui/card"
import type {
  SettingsStudySetting,
  SettingsTeleworkSetting,
} from "@/types/serializers"

const props = defineProps<{
  setting: SettingsTeleworkSetting | SettingsStudySetting
}>()

const currentSetting = computed(() => {
  switch (props.setting.id) {
    case "telework":
      return { icon: Laptop, component: SetTeleworkDialog }
    case "study":
      return { icon: GraduationCap, component: SetStudyDialog }
    default:
      return null
  }
})
</script>

<template>
  <Card v-if="currentSetting">
    <CardHeader class="flex flex-row items-center justify-between">
      <div class="flex items-center gap-3">
        <component
          :is="currentSetting.icon"
          class="text-muted-foreground size-5"
        />
        <CardTitle>{{ setting.name }}</CardTitle>
      </div>
      <component :is="currentSetting.component" :setting="setting">
        <Button variant="link" class="min-w-20">Configurar</Button>
      </component>
    </CardHeader>
  </Card>
</template>
